import { getName } from "country-list";
import UserDefaultLogo from "../../../assets/svg/user-avatar.svg";
import {
  IManagedStudentsBackEndModel,
  IManagedStudentsFrontEndModel,
  StudentStatus,
} from "../types";

function parser(student: IManagedStudentsBackEndModel) {
  const parsedProgram: IManagedStudentsFrontEndModel = {
    id: student.id,
    name: student.name,
    status:
      student.studentStatus === null
        ? StudentStatus.DEFAULT
        : student.studentStatus,
    photo: student.photo ? student.photo.preview : UserDefaultLogo,
    hasNewMessage: false, // todo replace hasNewMessage
    country: getName(student.studentProfile.country as string)!,
  };

  return parsedProgram;
}

export function parseToManagedStudentsFrontEndModel(response) {
  response.data = response.data?.map((student) => parser(student));

  return response;
}
